import { ImprovementProposal } from "@/schema/improvement-proposal/ImprovementProposal";
import MainCategoryResult from "@/src/_components/ImprovementProposalResult/MainCategoryResult";
import ResultHeading, { HeadingType } from "@/src/_components/ResultHeading";
import { useTranslation } from "react-i18next";

interface ImprovementProposalResultProps {
  improvementProposal: ImprovementProposal;
}

function ImprovementProposalResult({
  improvementProposal: { main_category_results, corporate_number, updated_at, registration_number },
}: ImprovementProposalResultProps) {
  const { t } = useTranslation();
  return (
    <>
      <div
        className="mx-4 mt-8 w-[1400px]  min-w-[1400px]  sm:mx-16"
        id="improvement-proposal"
      >
        <div className="w-full bg-white md:w-[720px] lg:w-[1120px] p-[36px]">
          <ResultHeading
            type={HeadingType.IMPROVEMENT_PROPOSAL}
            companyCode={registration_number ?? "---"}
            updatedAt={updated_at}
          />
          <div className="mt-[32px] w-[1220px] min-w-[1220px] flex flex-col gap-y-[24px]">
            <div className="flex flex-col rounded-[12px] shadow">
              <div className="my-[20px] mx-[24px]">
                <span className="text-cool-gray-900 text-[18px] leading-[28px]">
                  {t("assessment-details")}
                </span>
              </div>
              {main_category_results.map((data, index) => (
                <MainCategoryResult key={data.id} mainCategoryResult={data} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ImprovementProposalResult;
